import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';

export interface ItemMenu {
  iconActive: string;
	iconInactive: string;
	text: string;
	link: string;
  isActive: boolean;
  esMuisca: boolean;
}

@Component({
  selector: 'app-item-menu',
  templateUrl: './item-menu.component.html',
  styleUrls: ['./item-menu.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class ItemMenuComponent implements OnInit {

  @Input('model') model: ItemMenu;
  @Input('urlIngreso') urlIngreso: string = '';
  @Input('opened') opened: boolean = false;
  @Input('isLast') isLast: boolean = false;

  private basePath: string = window.location.origin;

  constructor() { }

  ngOnInit() {
  }

  redirect() {
    if (this.model.esMuisca) window.location.href = this.basePath + this.model.link;
    else window.location.href = this.basePath + '/' + this.urlIngreso + this.model.link;
  }

  stripTags(text: string) {
    const strippedString = text.replace(/(<([^>]+)>)/gi, "");
    return strippedString;
  }

}



// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/item-menu/item-menu.component.ts